import { computed, Ref } from '@vue/composition-api'

const textareaCursorDestinationId = '__PENDING_CURSOR_TEXTAREA_'

function makeId(id) {
  return textareaCursorDestinationId + id
}

export function moveCursor(partId, position, callback) {
  return setTimeout(() => {
    const textarea: HTMLInputElement = document.getElementById(
      makeId(partId)
    ) as HTMLInputElement

    if (textarea) {
      textarea.focus()
      textarea.setSelectionRange(position, position)
      return callback()
    }

    throw new Error(`
    Make sure that you added tracking id directly on EACH textarea.
    Example:  <textarea id="TRACKING_ID">1</textarea>`)
  })
}

export function useCursorDestinationId(partId: Ref<string>): Ref<string> {
  return computed(() => makeId(partId.value))
}
